import { render } from "./ReviewCycles.vue?vue&type=template&id=e4812284&scoped=true"
import script from "./ReviewCycles.vue?vue&type=script&lang=js"
export * from "./ReviewCycles.vue?vue&type=script&lang=js"

import "./ReviewCycles.vue?vue&type=style&index=0&id=e4812284&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4812284"]])

export default __exports__